import request from '@/utils/request'
import qs from 'qs'




export const allRoles = () => {
  return request({
    url: 'api/roles/all',
    method: 'GET'
  })
}

// 基本信息

export const userInfo = () => {
  return request({
    url: '/auth/info',
    method: 'GET'
  })
}

export const getUserInfo = (id) => {
  return request({
    url: 'api/users/info/' + id,
    method: 'GET'
  })
}
/**
 * 
 * 消息中心
 */
// 消息列表
export const queryMessage = params => {
  return request({
    url: '/api/news',
    method: 'GET',
    params
  })
}

// 创建新闻

export const creatNews = params => {
  return request({
    url: '/api/news',
    method: 'POST',
    data:params
  })
}

/**
 * 
 * 消息中心结束
 */

// 实名认证
export const certification = params => {
  return request({
    url: '/api/certification',
    method: 'POST',
    data:params
  })
}

// 修改密码的获取手机验证码 
export const resetSmsCode = params => {
  return request({
    url: '/api/code/resetSms',
    method: 'POST',
    data:params
  })
}


// 重置密码
export const updatePass = params => {
  return request({
    url: '/api/users/updatePass',
    method: 'POST',
    data:params
  })
}

// 用户认证列表
export const userDept = id => {
  return request({
    url: '/api/dept/'+id,
    method: 'GET'
  })
}

// 用户认证列表
export const userDeptList = params => {
  return request({
    url: '/api/userDept',
    method: 'GET',
    params
  })
}


export const deleteUserDept = id => {
  return request({
    url: '/api/userDept/remove/'+id,
    method: 'DELETE'
  })
}



/**
 * 企业
 * 个人中心
 * 产品统计
 * 
*/

// 个人中心报告证书展示

export const companySummary = () => {
  return request({
    url: '/api/enterprise/summary',
    method: 'GET'
  })
}

// 个人中心分类统计
export const companyclassifiedStatistic = () => {
  return request({
    url: '/api/enterprise/classifiedStatistic',
    method: 'GET'
  })
}

// 产品到期时间分布图
export const companyExpireMap = params => {
  return request({
    url: '/api/enterprise/expireMap',
    method: 'GET',
    params
  })
}

// 产品统计
export const productStatistic = params => {
  return request({
    url: '/api/enterprise/productStatistic',
    method: 'GET',
    params
  })
}
// table 表头
export const presentationCategory = params => {
  return request({
    url: '/api/categoryForReport',
    method: 'GET',
    params
  })
}

// pay
export const payMent = params => {
  return request({
    url: '/api/aliPay/toPayAsPCMember',
    method: 'POST',
    data:params
  })
}

/**
 * 中介
 * 个人中心
 * 产品统计
 * 
*/

// 基本信息
export const agencySummary = params => {
  return request({
    url: '/api/consultancy/summary',
    method: 'GET'
  })
}


export const agencyClassifiedStatistic = () => {
  return request({
    url: '/api/consultancy/classifiedStatistics',
    method: 'GET'
  })
}

// 产品到期时间分布图
export const agencyExpireMap = params => {
  return request({
    url: '/api/consultancy/expireMap',
    method: 'GET',
    params
  })
}

// 添加客户
export const invite = params => {
  return request({
    url: '/api/invite',
    method: 'POST',
    data:params
  })
}

// 添加客户
export const editInvite = params => {
  return request({
    url: '/api/invite',
    method: 'PUT',
    data:params
  })
}

// /manage客户管理

export const clientManage = params => {
  return request({
    url: '/api/manage',
    method: 'GET',
    params
  })
}


/**
 * 超级管理员
 * 个人中心
 * 用户管理
 * 咨询机构管理
 * 
*/

//个人中心
export const adminUser = () => {
  return request({
    url: '/api/administrator/user',
    method: 'GET'
  })
}
export const adminDept = () => {
  return request({
    url: '/api/administrator/dept',
    method: 'GET'
  })
}

export const adminUserMap = params => {
  return request({
    url: '/api/administrator/userMap',
    method: 'GET',
    params
  })
}
export const addUser = params => {
  return request({
    url: '/api/users',
    method: 'POST',
    data:params
  })
}


// 添加用户/api/invite

export const addClient = params => {
  return request({
    url: '/api/invite',
    method: 'POST',
    data:params
  })
}

export const deptManage = params => {
  return request({
    url: '/api/administrator/deptManage',
    method: 'GET',
    params
  })
}

export const getAgencyManage = params => {
  return request({
    url: '/api/toManage',
    method: 'GET',
    params
  })
}

// 
// 禁用/启用企业
export const adminDisable = params => {
  return request({
    url: '/api/administrator/disable',
    method: 'PUT',
    data:params
  })
}

// 中介状态更改

export const adminMediation = params => {
  return request({
    url: '/api/administrator/mediation',
    method: 'PUT',
    data:params
  })  
}

//  中介
export const deptOrgManage = params => {
  return request({
    url: '/api/administrator/deptOrgManage',
    method: 'GET',
    params
  })
}

// 退出企业

export const deleteCompany = () => {
  return request({
    url: '/api/groupusers/quit',
    method: 'DELETE',
  })
}

export const quiteCompany = (params) => {
  return request({
    url: '/api/dept/quit',
    method: 'DELETE',
    data: params
  })
}
